import React, { useState, useEffect } from 'react';
import { FixedSizeList as List } from 'react-window';
import { ApCheckbox } from '@alixpartners/ui-components';
import { useWindowResize } from 'utils/useWindowResize';
import { ListItem, CheckboxLabel } from './FilterOptions.styles';

const ITEM_HEIGHT = 40;

const Row = ({ data, index, selected, onChange }) => {
	const rowData = data[index];

	return (
		<ListItem
			onClick={e => {
				e.preventDefault();

				if (!rowData.disabled) {
					onChange(rowData);
				}
			}}
		>
			<ApCheckbox
				onChange={() => {}}
				checked={selected.includes(rowData.value)}
				disabled={rowData.disabled}
			/>
			<CheckboxLabel disabled={rowData.disabled}>{rowData.label}</CheckboxLabel>
		</ListItem>
	);
};

export const VirtualList = ({ data, selected, onChange, wrapperRef }) => {
	const [height, setHeight] = useState(0);
	const [, windowHeight] = useWindowResize();

	useEffect(
		() => {
			if (wrapperRef && wrapperRef.current) {
				setHeight(wrapperRef.current.clientHeight);
			}
		},
		[wrapperRef, windowHeight]
	);

	return (
		<List
			height={height}
			width="100%"
			itemCount={data.length}
			itemSize={ITEM_HEIGHT}
			itemData={data}
		>
			{({ data, index, style }) => (
				<div style={style}>
					<Row
						data={data}
						index={index}
						selected={selected}
						onChange={onChange}
					/>
				</div>
			)}
		</List>
	);
};
